// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lr-card-container {
  border-bottom: solid 1px #e6e6e6;
  padding-bottom: 15px;
  margin-bottom: 15px;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
}
.lr-card-details {
  font-weight: normal;
  margin-bottom: 0;
  flex-grow: 1;
}
.lr-heading,
.lr-textbox,
.lr-save-btn {
  width: 100%;
  flex-basis: 100%;
}
.lr-textbox {
  position: relative;
  margin-bottom: 20px;
}
.lr-textbox input {
  padding-right: 56px;
}
.lr-edit-btn,
.lr-save-btn {
  background: none;
  border: none;
}
.lr-text-clear {
  background: none;
  border: none;
  margin: 0;
  padding: 0;
  position: absolute;
  top: 0;
  right: 0;
  width: 24px;
  height: 24px;
  z-index: 5;
}

input {
  margin-bottom: 10px;
}
select {
  margin-bottom: 10px;
}
.lr-mt {
  margin-top: 25px;
}
.-padding-left-7  {
  padding-left: 7px;
}

.-padding-right-7  {
  padding-right: 7px;
}
.-padding-left-right {
  padding-right: 15px;
  padding-left: 15px;
}
.lr-eyebrow {
  color: #6e6e6e;
  text-align: center;
}
.zip {
font-size: 14px;
}
.olr-icon-close-filled {
  background-image: url('icon-close-filled.svg');
  width: 24px;
  height: 20px;
  background-repeat: no-repeat;
  background-size: contain;
  display: block;
}
`, "",{"version":3,"sources":["webpack://./projects/lossreporting-library/src/lib/shared/card-address-editable/card-address-editable.component.css"],"names":[],"mappings":"AAAA;EACE,gCAAgC;EAChC,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;AACd;AACA;;;EAGE,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;;EAEE,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,kBAAkB;AACpB;AACA;AACA,eAAe;AACf;AACA;EACE,8CAAgE;EAChE,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,wBAAwB;EACxB,cAAc;AAChB","sourcesContent":[".lr-card-container {\n  border-bottom: solid 1px #e6e6e6;\n  padding-bottom: 15px;\n  margin-bottom: 15px;\n  width: 100%;\n  display: flex;\n  flex-wrap: wrap;\n}\n.lr-card-details {\n  font-weight: normal;\n  margin-bottom: 0;\n  flex-grow: 1;\n}\n.lr-heading,\n.lr-textbox,\n.lr-save-btn {\n  width: 100%;\n  flex-basis: 100%;\n}\n.lr-textbox {\n  position: relative;\n  margin-bottom: 20px;\n}\n.lr-textbox input {\n  padding-right: 56px;\n}\n.lr-edit-btn,\n.lr-save-btn {\n  background: none;\n  border: none;\n}\n.lr-text-clear {\n  background: none;\n  border: none;\n  margin: 0;\n  padding: 0;\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 24px;\n  height: 24px;\n  z-index: 5;\n}\n\ninput {\n  margin-bottom: 10px;\n}\nselect {\n  margin-bottom: 10px;\n}\n.lr-mt {\n  margin-top: 25px;\n}\n.-padding-left-7  {\n  padding-left: 7px;\n}\n\n.-padding-right-7  {\n  padding-right: 7px;\n}\n.-padding-left-right {\n  padding-right: 15px;\n  padding-left: 15px;\n}\n.lr-eyebrow {\n  color: #6e6e6e;\n  text-align: center;\n}\n.zip {\nfont-size: 14px;\n}\n.olr-icon-close-filled {\n  background-image: url(../../../assets/img/icon-close-filled.svg);\n  width: 24px;\n  height: 20px;\n  background-repeat: no-repeat;\n  background-size: contain;\n  display: block;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
